export { renderBadge_unstable as renderPresenceBadge } from '@fluentui/react-badge';
